import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionProps,
} from '@mui/material';
import { ReactNode, useState } from 'react';
import VegaCardV2, { VegaCardV2Props } from './VegaCardV2';

interface VegaAccordianV2 extends Omit<AccordionProps, 'children'> {
  collapsedView: ReactNode;
  expandedView: ReactNode;
  expanded: boolean;
  collapsedViewActions?: ReactNode;
  expandedViewActions?: ReactNode;
  collapsedViewCardProps?: VegaCardV2Props;
  expandedViewCardProps?: VegaCardV2Props;
}

function VegaAccordianV2({
  collapsedView,
  expandedView,
  expanded,
  collapsedViewActions,
  expandedViewActions,
  collapsedViewCardProps,
  expandedViewCardProps,
  ...rest
}: VegaAccordianV2) {
  function getActions() {
    if (expanded) {
      return expandedViewActions;
    }
    return collapsedViewActions;
  }

  return (
    <Accordion
      {...rest}
      sx={{
        '&.MuiPaper-root': {
          boxShadow: 'none !important',
          border: 'none !important',
          backgroundColor: 'transparent',
        },
        '& .MuiAccordionSummary-root': {
          borderRadius: '10px',
          '& .Mui-expanded': {
            margin: 0,
            padding: 0,
          },
        },
        // '.css-163jq61-MuiPaper-root-MuiAccordion-root:before': {
        //   display: 'none',
        //   height: '0px',
        // },
        '&:before': {
          display:'none'
        },
        '& .Mui-expanded': {
          borderBottomLeftRadius: '0px !important',
          borderBottomRightRadius: '0px !important',
        },
      }}
      expanded={expanded}
    >
      <AccordionSummary
        sx={{
          width: '100%',
          padding: 0,
          border: 'none !important',

          '& .MuiAccordionSummary-contentGutters': {
            padding: '0rem',
            margin: '0rem',
          },
        }}
      >
        <VegaCardV2
          {...collapsedViewCardProps}
          flexDirection="row"
          justifyContent={'space-between'}
          alignItems={'center'}
          width="100%"
          noBottomBorderRadius={expanded}
        >
          {collapsedView}

          {getActions()}
        </VegaCardV2>
      </AccordionSummary>
      <AccordionDetails
        sx={{
          width: '100%',
          border: 'none',
          margin: 0,
          padding: 0,
        }}
      >
        <VegaCardV2
          {...collapsedViewCardProps}
          flexDirection="row"
          justifyContent={'space-between'}
          alignItems={'center'}
          width="100%"
          noTopBorderRadius={expanded}
        >
          {expandedView}
        </VegaCardV2>
      </AccordionDetails>
    </Accordion>
  );
}

export default VegaAccordianV2;
